import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./i18nsetup";
import routes from "./routes";
import "./App.css";

const router = createBrowserRouter(routes);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
